import { render, staticRenderFns } from "./studySignList.vue?vue&type=template&id=d56d52de&scoped=true"
import script from "./studySignList.vue?vue&type=script&lang=js"
export * from "./studySignList.vue?vue&type=script&lang=js"
import style0 from "./studySignList.vue?vue&type=style&index=0&id=d56d52de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56d52de",
  null
  
)

export default component.exports